import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Button,
  Paper,
} from "@material-ui/core";
import * as React from "react";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    button: {
      margin: theme.spacing(1),
      width: "30%",
      height: 48,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
  });
interface Props extends WithStyles<typeof styles> {
  text: any;
  onClick: any;
  type?: any;
  disabled?: any;
}
class ButtonComponent extends React.Component<Props> {
  render() {
    const { classes, text, disabled, type, onClick } = this.props;
    return (
      <React.Fragment>
        <Paper
          style={{
            width: "40%",
            height: "100%",
            borderRadius: 10,
            overflow: "hidden",
            backgroundColor: !disabled ? "#f96500" : "white",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Button
            style={{ width: "100%", color: !disabled ? "white" : "grey" }}
            type={type}
            disabled={disabled}
            className={classes.button}
            onClick={onClick}
          >
            {text}
          </Button>
        </Paper>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(ButtonComponent);
